import {
  REFERRAL_ATTRIBUTION_WINDOW_DAYS_DEFAULT,
  REFERRAL_COOKIE_NAME,
} from "@/lib/referral/constants"

const COOKIE_MAX_AGE_SECONDS = REFERRAL_ATTRIBUTION_WINDOW_DAYS_DEFAULT * 24 * 60 * 60

const CODE_PATTERN = /^[A-Za-z0-9]{6,16}$/

export function normalizeReferralCode(raw: string | null | undefined): string | null {
  if (!raw) return null
  const code = raw.trim().toUpperCase()
  if (!CODE_PATTERN.test(code)) return null
  return code
}

export function isPlausibleReferralCode(code: string): boolean {
  return CODE_PATTERN.test(code.trim().toUpperCase())
}

export function readReferralCodeFromDocumentCookie(
  cookieHeader: string,
  name = REFERRAL_COOKIE_NAME,
): string | null {
  if (!cookieHeader?.trim()) return null
  const prefix = `${name}=`
  for (const part of cookieHeader.split("; ")) {
    if (!part.startsWith(prefix)) continue
    try {
      const raw = decodeURIComponent(part.slice(prefix.length)).trim()
      return normalizeReferralCode(raw)
    } catch {
      return null
    }
  }
  return null
}

/** Cookie com Max-Age alinhado à janela de atribuição (padrão 30 dias), SameSite=Lax. */
export function buildReferralCodeSetCookieValue(
  code: string,
  isSecure: boolean,
  maxAgeSeconds: number = COOKIE_MAX_AGE_SECONDS,
): string {
  const safe = code.trim().toUpperCase()
  return `${REFERRAL_COOKIE_NAME}=${encodeURIComponent(safe)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${isSecure ? "; Secure" : ""}`
}
